import styled from 'styled-components';
import { skills } from './SkillsData';
import { skillsColor } from '../../Components/Helpers/GlobalStyle';

const ChartsAnimationS = (props) => {
  return (
    <div id="chartsS" className={props.className}>
      <div className="box">
        <div className="barChart">
          <div className="animation" id="chart-0"></div>
        </div>
        <div className="name"> {skills[0].name}</div>
      </div>

      <div className="box">
        <div className="barChart">
          <div className="animation" id="chart-1"></div>
        </div>
        <div className="name"> {skills[1].name}</div>
      </div>

      <div className="box">
        <div className="barChart">
          <div className="animation" id="chart-2"></div>
        </div>
        <div className="name"> {skills[2].name}</div>
      </div>

      <div className="box">
        <div className="barChart">
          <div className="animation" id="chart-3">
            {/* {skills[3].percent} */}
          </div>
        </div>
        <div className="name"> {skills[3].name}</div>
      </div>
    </div>
  );
};

export default styled(ChartsAnimationS)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  @media (max-width: 768px) {
    align-items: center;
  }

  .box {
    padding: 0.4rem;
    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .barChart {
    border: solid 3px ${skillsColor};
    border-radius: 100px;
    line-height: 1rem;
    width: 100%;
  }

  .animation {
    background-color: ${skillsColor};
    width: 0;
    height: 0.8rem;
    margin: 0.2rem;
    border-radius: 100px;
    line-height: 0.8rem;
  }

  .name {
    padding-left: 1rem;
    text-align: start;
    font-weight: bold;
  }

  #chart-0 {
    animation: bar-0 4s ease-in 1s alternate both;
  }

  #chart-1 {
    animation: bar-1 4s ease-in 1s alternate both;
  }

  #chart-2 {
    animation: bar-2 4s ease-in 1s alternate both;
  }
  #chart-3 {
    animation: bar-3 4s ease-in 1s alternate both;
  }

  @keyframes bar-0 {
    100% {
      width: ${`${skills[0].percent}%`};
    }
  }
  @keyframes bar-1 {
    100% {
      width: ${`${skills[1].percent}%`};
    }
  }
  @keyframes bar-2 {
    100% {
      width: ${`${skills[2].percent}%`};
    }
  }

  @keyframes bar-3 {
    100% {
      width: ${`${skills[3].percent}%`};
    }
  }
`;
